import { captureSubmissionError } from "./sentryUtils";

// Use a stable label for URLs containing ids so Sentry groups failures. Report
// only the status because error bodies contain client data. Retrying callers
// can defer capture to report once per run.
export const request = async (url, { sentryLabel = url, sentryCapture = true, ...fetchOptions } = {}) => {
  // Every body these endpoints send is JSON.stringify output, so the header
  // that says so belongs here rather than at each call site. A caller that
  // sends something else says so itself and keeps its own header.
  const headers =
    fetchOptions.body == null ? fetchOptions.headers : { "Content-Type": "application/json", ...fetchOptions.headers };

  const response = await fetch(url, { ...fetchOptions, headers });

  if (!response.ok) {
    if (sentryCapture) {
      captureSubmissionError(sentryLabel, response.status, "");
    }
    throw new Error(`HTTP ${response.status}`);
  }

  // Not every endpoint answers with a body. The contact-executor POST reads
  // nothing back, so a 204 or an empty 200 is a success with nothing in it
  // rather than the parse error response.json() would raise.
  const body = await response.text();
  return body === "" ? null : JSON.parse(body);
};
